import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

export const getModifierCodes = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/modifier-codes`);
    return response.data;
  } catch (error) {
    console.error('Error fetching modifier codes:', error.response?.data || error);
    throw error;
  }
};

export const createModifierCode = async (data) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/modifier-codes`, data);
    return response.data;
  } catch (error) {
    console.error('Error creating modifier code:', error.response?.data || error);
    throw error;
  }
};

export const updateModifierCode = async (id, data) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/modifier-codes/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating modifier code:', error.response?.data || error);
    throw error;
  }
};

export const deleteModifierCode = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/modifier-codes/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting modifier code:', error.response?.data || error);
    throw error;
  }
};
